function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 26.361 26.362"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M24.362 0H2a2 2 0 00-2 2v22.36a2 2 0 002 2h22.361a2 2 0 002-2V2c.001-1.104-.894-2-1.999-2zm-6.346 15.182H8.348a2 2 0 010-4h9.667a2 2 0 01.001 4z"
})));